import React, { useEffect, useMemo, useState } from 'react';
import { api } from '../scripts/api';
import CardComponent from '../components/CardComponent';


export default function SoldPage() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState(() => sessionStorage.getItem('sold_q') || '');
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState('');

  useEffect(() => {
    sessionStorage.setItem('sold_q', q);
  }, [q]);

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        setLoading(true);
        setErrMsg('');

        // axios baseURL "/api" -> "/api/sold_inventory"
        const res = await api.get('/sold_inventory');

        if (!alive) return;

        const data = res?.data;
        if (Array.isArray(data)) {
          setRows(data);
        } else {
          setRows([]);
          setErrMsg(`Unexpected response: ${typeof data}`);
          console.error('Sold unexpected response:', data);
        }
      } catch (e) {
        console.error('Load sold failed', e);
        if (!alive) return;
        setRows([]);
        setErrMsg('Failed to load sold inventory (check console/network).');
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return rows;
    return rows.filter((r) => JSON.stringify(r).toLowerCase().includes(s));
  }, [rows, q]);

  return (
    <div className="container">
      <div className="row">
        <input
          className="input"
          placeholder="Search…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>

      {loading && <div className="muted">Loading…</div>}
      {!loading && errMsg && <div className="muted">{errMsg}</div>}
      {!loading && !errMsg && filtered.length === 0 && <div className="muted">No records.</div>}

      <div className="col">
        {filtered.map((r) => (
          <CardComponent key={r.id} record={r} table="sold_inventory" />
        ))}
      </div>
    </div>
  );
}
